import { useState, useEffect, useRef, Fragment, useContext } from 'react'
import Image from 'next/image'
import Router from 'next/router'
import { Button, Modal } from 'antd'
import numeral from 'numeral'
import NodeRSA from 'node-rsa'
import { FormattedMessage, injectIntl } from 'react-intl'
import { resCodeMsg } from '@/components/resCodeMsg';

import { initialQuery, checkoutPayment, paymentJaPayflow } from '@/components/H5PC/service'
import { CommonError } from '@/components/H5PC/CommonMethod.js'

import myContext from '@/utils/createContext';


const LinePay = props => {
  const { intl } = props


  const { urlParams, checkPolling, type, payData, isMobileView, publicKey, key, token, setLoading } = useContext(myContext) || {}

  console.log('1111', type)

  const { loading,
    actualPaymentAmount,
    actualPaymentCurrency } = useContext(myContext);

  const { formatMessage } = intl;

  useEffect(() => {

  }, [])



  const renderText = () => { 
    const _html = type === 'rabbit_line_pay' ?
      <div className='line-pay'>
        <p>
          <FormattedMessage id="linepay.desc1" />
        </p>
        <p>
          <FormattedMessage id="linepay.desc2" />
        </p>
        <p>
          <FormattedMessage id="linepay.desc3" />
        </p>
        <p>
          <FormattedMessage id="linepay.desc4" />
        </p>
      </div>
      :
      <div className='product-text-666'>
        <p>
          <FormattedMessage id={`alipay+.${type}.tip`} />
        </p>
        <div className='product-pay-icon-space'>
          {/* 兼容线上图片大小写问题 */}
          <Image src={`/static/images/alipay/${type === 'dana' ? 'DANA' : 'BPI'}.svg`} alt={type} width={141} height={46} />
        </div>
    </div>
    return _html
  }
  return (
    <div>
      { renderText() }

      <div className="h5pc-submit">
        <Button
          className="h5pc-submit-btn"
          type="primary"
          htmlType="submit"
          loading={loading}
          // onClick={() => handlePay(token, publicKey)}
        >

          <span className="lock-img" ></span>
          {formatMessage({ id: 'ga-checkout.pay' })} &nbsp;
          {actualPaymentAmount} {actualPaymentCurrency}
        </Button>
      </div>
    </div>
  )
}

export default injectIntl(LinePay)
